function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { Button } from "../..";

// Local Definitions

import "./styles.scss";
const baseClassName = styleNames.base;
const componentClassName = 'notification';
const iconsMap = {
  success: 'I',
  error: 'g',
  warning: 'x',
  info: 'h'
};
const COLORS_MAP = {
  success: 'success',
  error: 'error',
  warning: 'blocked',
  info: 'in-progress'
};
const Notification = ({
  id,
  className: userClassName,
  style,
  color,
  message,
  type,
  isVisible,
  overrideIsVisible,
  closeNotification,
  ...otherProps
}) => {
  const [isVisibleState, setIsVisibleState] = useState(isVisible);
  if (!isVisibleState && !overrideIsVisible) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: [baseClassName, componentClassName, userClassName, `x-${color || COLORS_MAP[type]}`].filter(e => e).join(' '),
    style: style
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: "message-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, iconsMap[type]), /*#__PURE__*/React.createElement("span", {
    className: "message"
  }, message)), /*#__PURE__*/React.createElement(Button, {
    className: "close",
    isCompact: true,
    color: color || COLORS_MAP[type],
    onClick: () => {
      if (closeNotification) closeNotification();
      setIsVisibleState(false);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, "Y")));
};
Notification.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The color of the notification
   */
  color: PropTypes.string,
  /**
   * The message of the notification
   */
  message: PropTypes.string,
  /**
   * The type of the notification
   */
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  /**
   * The visibility of the notification
   */
  isVisible: PropTypes.bool,
  /**
   * Override the visibility of the notification
   */
  overrideIsVisible: PropTypes.bool,
  /**
  * The action to close the notification
  */
  closeNotification: PropTypes.func
};
Notification.defaultProps = {
  isVisible: true,
  overrideIsVisible: false,
  type: 'error'
};
export default Notification;